import { createSelector } from '@reduxjs/toolkit';

import { commentSelectTotal } from '@/Module/Comment/Store/Selector/index';
import type { IState } from '@/Module/Store/Model';

export const commentListHasNextPageSelector = createSelector(
  [(state: IState) => state.comment.total, (state: IState) => commentSelectTotal(state)],
  (total, commentCount) => {
    return total > commentCount;
  },
);
